import * as React from 'react';
import { registerDecorator } from '@avensia/excite-contentful/Document';
import { styled } from '@glitz/react';
import { createMinLargeViewportDecorator } from 'webapp/viewport';
import { isSvenssons } from 'webapp/theme';

registerDecorator<Excite.Contentful.ParagraphApiModel>(
  'p',
  styled(({ children, attributes }) => {
    if (!children || children.length === 0) {
      return null;
    }

    if (typeof children === 'string') {
      return <P {...attributes} dangerouslySetInnerHTML={{ __html: children as string }} />;
    }
    return <P {...attributes}>{children}</P>;
  }),
);

const P = styled.p(
  createMinLargeViewportDecorator({
    marginBottom: t => (isSvenssons ? t.sharedSpacing.l : t.sharedSpacing.xxl),
  }),
  {
    marginBottom: t => (isSvenssons ? t.sharedSpacing.m : t.sharedSpacing.l),
  },
  !isSvenssons && {
    fontSize: t => t.sharedFontSize.xs,
    lineHeight: t => 24 / t.sharedFontSize.xs,
  },
);

registerDecorator<Excite.Contentful.ParagraphApiModel>(
  'span',
  styled(({ children, attributes }) => {
    if (!children || children.length === 0) {
      return null;
    }
    if (typeof children === 'string') {
      return <Span {...attributes} dangerouslySetInnerHTML={{ __html: children as string }} />;
    }

    return <Span {...attributes}>{children}</Span>;
  }),
);

const Span = styled.span();
